// @flow

import React from 'react';
import { Helmet } from 'react-helmet-async';

type BaseMetaTypes = {
  canonicalUrl: string,
  description: string,
  title: string,
};
const BaseMeta = ({ title, canonicalUrl, description }: BaseMetaTypes) => {
  return (
    <Helmet prioritizeSeoTags>
      {title ? <title>{title}</title> : null}
      {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
      {description ? <meta name="description" content={description} /> : null}
    </Helmet>
  );
};
export default BaseMeta;
